import { render, staticRenderFns } from "./external-accounts-add-clio-acct.vue?vue&type=template&id=5a6f0b1c&scoped=true"
import script from "./external-accounts-add-clio-acct.vue?vue&type=script&lang=js"
export * from "./external-accounts-add-clio-acct.vue?vue&type=script&lang=js"
import style0 from "./external-accounts-add-clio-acct.vue?vue&type=style&index=0&id=5a6f0b1c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6f0b1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\User\\Documents\\legalmerge-prod\\legal-merge\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a6f0b1c')) {
      api.createRecord('5a6f0b1c', component.options)
    } else {
      api.reload('5a6f0b1c', component.options)
    }
    module.hot.accept("./external-accounts-add-clio-acct.vue?vue&type=template&id=5a6f0b1c&scoped=true", function () {
      api.rerender('5a6f0b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin_settings/components/external-accounts/external-accounts-add-clio-acct.vue"
export default component.exports